module.exports = __webpack_public_path__ + "static/media/file-download.df34aea0.svg";